var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .net-1 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .net-1, .net-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "net-1",
    x: 7.95,
    y: 7.62,
    width: 31.63,
    height: 37.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "net-1",
    x: 10.7,
    y: 10.5,
    width: 26.13,
    height: 8.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "net-1",
    x: 30.95,
    y: 13.37,
    width: 2.88,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "net-1",
    x: 25.2,
    y: 13.37,
    width: 2.88,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "net-1",
    x: 10.7,
    y: 22,
    width: 26.13,
    height: 8.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "net-1",
    x: 19.45,
    y: 24.87,
    width: 2.88,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "net-1",
    x: 13.7,
    y: 24.87,
    width: 2.88,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "net-1",
    x: 10.7,
    y: 33.5,
    width: 26.13,
    height: 8.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "net-1",
    x: 30.95,
    y: 36.37,
    width: 2.88,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "net-1",
    x: 19.45,
    y: 36.37,
    width: 2.88,
    height: 2.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "net-1",
    points: "10.42 5 42.05 5 42.05 42.38"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "net-2",
    width: 50,
    height: 50
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetwork);
export default __webpack_public_path__ + "static/media/icon-network.8924c2612671dafe6bf44623bae3c763.svg";
export { ForwardRef as ReactComponent };